import type { FaireProductEntity } from "../../entity_types/product";

export const p_xu9h3adx9r: FaireProductEntity = {
  token: "p_xu9h3adx9r",
  type: "product",
  name: "Sage Meadow Thank You Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl: "https://cdn.faire.com/fastly/70bd89de20e874837546fe8d372d409dd43e22c53a622923535807140387927a.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6fd20c5bb836b9f21d5b69ab4c896f0647bf33f79883b5890abb6f252e1053bf.png",
    "https://cdn.faire.com/fastly/74ab1cd9106044f417b52f0e044809290a67c60ba1caf2733f3d7dce8df65fb0.png"
  ],
  priceDollars: 3,
  description: "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:08.729Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
